import React from 'react';

import ExportedImage from 'next-image-export-optimizer';

import { motion } from 'framer-motion';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';
import HeroWidget from '@/components/shared/lp/home/HeroWidget';

import { siteData } from '@/data/configs/site';
import gradientLinkArrow from '@/public/images/lp/svgs/gradient-link-arrow.svg';
import { CoinData } from '@/store/home/types';

interface HeroProps {
  data?: CoinData;
}

export default function Hero({ data }: HeroProps) {
  return (
    <section
      className='lg::pt-36 relative z-[12] flex flex-col items-center justify-between pt-24 lg:min-h-screen lg:flex-row lg:pt-12'
      id='hero-section'
    >
      <div className='flex flex-col space-y-5 md:w-[80%] lg:w-2/4 3xl:space-y-7 -lg:mx-auto -lg:mb-16 -lg:items-center -lg:text-center'>
        <AnimateWhileInView>
          <span className='home-small-header font-sans text-xs font-normal uppercase sm:text-sm xl:text-base 2xl:text-lg'>
            REAL WEB3 EMPOWERMENT
          </span>
        </AnimateWhileInView>
        <h1 className='flex flex-col font-sans text-4xl font-medium sm:text-5xl md:text-[56px] lg:text-6xl lg:leading-[4rem] 2xl:text-[73px] 2xl:leading-none 3xl:text-8xl'>
          <AnimateWhileInView delay={0.2}>
            <span>Join the</span>
          </AnimateWhileInView>
          <AnimateWhileInView delay={0.3}>
            <span className='trustless-gradient font-medium'>Trustless</span>
          </AnimateWhileInView>
          <AnimateWhileInView delay={0.4}>
            <span>(d)experience</span>
          </AnimateWhileInView>
        </h1>
        <AnimateWhileInView delay={0.5}>
          <p className='text-base text-gray-200 sm:text-lg md:text-xl xl:text-2xl'>
            Eliminate the middleman and take real control of what you own. Wallet, DEX and Bridge
            all-in-one platform compatible with <span className='ninety-nine-gradient'> 99%</span>{' '}
            of crypto assets.
          </p>
        </AnimateWhileInView>

        <AnimateWhileInView delay={0.6}>
          <div className='mx-auto flex flex-wrap justify-start gap-4 pt-4 xs:gap-6 sm:flex-nowrap md:justify-center lg:justify-start xl:px-0'>
            <motion.a href={siteData.webDEXlink} className='' target='_blank'>
              <motion.button
                type='button'
                className={`hero-btn justify-left relative flex w-[161px] flex-row items-center overflow-hidden rounded-[14px] border border-none px-3 py-2 font-sans text-base font-bold text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
                whileHover={{
                  y: -4,
                  boxShadow: '0 4px 15px rgba(84, 104, 230, 0.6)',
                  transition: { duration: 0.2 },
                }}
                whileTap={{ scale: 0.95 }}
              >
                <motion.span>Launch Wallet</motion.span>
                <ExportedImage
                  placeholder='empty'
                  src={gradientLinkArrow}
                  className='h-[19px] w-auto pl-[7px]'
                  width={16}
                  height={17}
                  alt='link'
                />
              </motion.button>
            </motion.a>
          </div>
        </AnimateWhileInView>
      </div>
      <div className='relative h-full w-full'>
        <AnimateWhileInView delay={0.5}>
          <HeroWidget data={data} />
        </AnimateWhileInView>
      </div>
    </section>
  );
}
